import store from '../../store';
const axios = require('axios').default;

export default {
    get: async function (path) {
        let result = null;
        const options = await getHeader();
        await axios.get(path, options)
            .then(response => {
                result = response.data;
            })
            .catch(async err => {
                console.log(err);
                throw err;
            });

        return result;
    },
    post: async function (path, body) {
        let result = null;
        const options = await getHeader();

        await axios.post(path, body, options)
            .then(response => {
                result = response.data;
            })
            .catch(async err => {
                console.log(err);
                throw err;
            });

        return result;
    },
    put: async function (path, body) {
        let result = null;
        const options = await getHeader();

        await axios.put(path, body, options)
            .then(response => {
                result = response.data;
            })
            .catch(async err => {
                console.log(err);
                throw err;
            });

        return result;
    },
    del: async function (path, body) {
        let result = null;
        const options = await getHeader();
        options.data = body;
        await axios.delete(path, options)
            .then(response => {
                result = response.data;
            })
            .catch(async err => {
                console.log(err);
                throw err;
            });
        return result;
    }
}

async function getHeader() {
    const accessToken = store.state.auth.idToken;
    let options = {
        headers:
        {
            'Access-Control-Allow-Origin': '*'
        }
    };

    if (accessToken) {
        options.headers.Authorization = `Bearer ${accessToken}`
    }
    return options;
}



// WEBPACK FOOTER //
// ./src/services/rest/rest-service.js